import { usePTPConfigContext } from 'GlobalConfig.context';
import { Stack } from 'components/Stack';
import HelperText from 'components/HelperText';
import { CustomText } from 'components/CustomText';
import { CommentSection } from '../CommentSection';
import { LineItemsSection } from '../LineItemsSection';
import { AttachmentsSection } from '../AttachmentsSection';
import { ReturnSubmissionFormData } from '../../../../interfaces/ReturnRequest.interface';

interface ViewModeProps {
  returnData: ReturnSubmissionFormData;
  error: string;
  formTitleId?: string;
}

export const ViewMode = ({
  returnData,
  error,
  formTitleId,
}: ViewModeProps): JSX.Element => {
  const {
    return: { customText, formSection },
  } = usePTPConfigContext();

  const { hideUpload, hideComment } = formSection || {};

  return (
    <Stack direction="column" gap={16}>
      <LineItemsSection selectedLineItems={returnData.selectedLineItems} />
      {!hideComment && <CommentSection comment={returnData.comment} />}
      {!hideUpload && (
        <AttachmentsSection attachments={returnData.attachments} />
      )}
      <CustomText text={customText.returnForm?.text} />
      {error && (
        <HelperText isError size="sm">
          {error}
        </HelperText>
      )}
    </Stack>
  );
};
